import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SiModalModule } from '../si-modal';
import { ActionConfirmationDialogComponent } from './action-confirmation-dialog.component';

@NgModule({
    declarations: [ActionConfirmationDialogComponent],
    imports: [CommonModule, FontAwesomeModule, SiModalModule],
    exports: [ActionConfirmationDialogComponent]
})
export class ActionConfirmationDialogModule {}
